function initNavigation() {
	var swapStyles = $('.si-nav-style__js');
	var swapImages = $('.si-img-swap__js');
	var buttonType = globalVar.buttonType;

	// swap all style related images
	swapImages.each(function (idx, image) {
		$(image).attr('src', function (index, attr) {
			return attr.replace('classic', buttonType);
		});
	});
	swapStyles.each(function (idx, nav) {
		$(nav).addClass('si-nav-style-' + buttonType);
	});

	attachNavEventListeners();
}

function showNavElements() {
	var navButtons = $('.si-nav__js');
	var iconClasses = 'si-click-icon si-drag-up-icon si-drag-down-icon si-drag-left-icon si-drag-right-icon';
	var $click = $('#si-click-icon');
	$(navButtons).hide();
	$click.removeClass(iconClasses);

	if (slides[globalVar.curSlide].navElements === undefined) {
		slides[globalVar.curSlide].navElements = [];
	}

	var navigation = slides[globalVar.curSlide].navElements;
	navigation.forEach(function (nav) {
		switch (nav) {
			case 'start-slide':
				$('#si-clock').show();
				$('#si-start').show();
				break;
			case 'standard-home':
				$('#si-logo').show();
				$('#si-progress').show();
				$('#si-home').show();
				$('#si-back').show();
				if (slideCompletion[globalVar.curSlide]) {
					$('#si-next').show();
				}
				break;
			case 'standard-menu':
				$('#si-logo').show();
				$('#si-progress').show();
				$('#si-menu').show();
				$('#si-back').show();
				if (slideCompletion[globalVar.curSlide]) {
					$('#si-next').show();
				}
				break;
			case 'exit-slide':
				$('#si-progress').show();
				$('#si-exit').show();
				$('#si-replay').show();
				break;
			case 'click-icon':
				$click
					.show()
					.removeClass(iconClasses)
					.addClass('si-' + nav);
				hideClickIcon();
				break;
			case 'drag-up-icon':
				$click
					.show()
					.removeClass(iconClasses)
					.addClass('si-' + nav);
				hideClickIcon();
				break;
			case 'drag-down-icon':
				$click
					.show()
					.removeClass(iconClasses)
					.addClass('si-' + nav);
				hideClickIcon();
				break;
			case 'drag-left-icon':
				$click
					.show()
					.removeClass(iconClasses)
					.addClass('si-' + nav);
				hideClickIcon();
				break;
			case 'drag-right-icon':
				$click
					.show()
					.removeClass(iconClasses)
					.addClass('si-' + nav);
				hideClickIcon();
				break;
			default:
				if (nav[0] === '!') $('#si-' + nav.split('!')[1]).hide();
				else $('#si-' + nav).show();
				break;
		}
	});
}

function attachNavEventListeners() {
	$('#si-home').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(globalVar.homeSlide);
	});

	$('#si-menu').on('click touch', function () {
		siAudio.sfx.click.play();
		openSideMenu();
	});

	$('#si-full').on('click touch', function () {
		siAudio.sfx.click.play();
		toggleFullscreen();
	});

	$('#si-back').on('click touch', function () {
		siAudio.sfx.click.play();
		setTimeout(function () {
			if (slides[globalVar.curSlide].backAction) {
				slides[globalVar.curSlide].backAction();
			} else {
				prevSlide();
			}
		}, 100);
	});

	$('#si-next').on('click touch', function () {
		siAudio.sfx.click.play();
		setTimeout(function () {
			if (slides[globalVar.curSlide].nextAction) {
				slides[globalVar.curSlide].nextAction();
			} else {
				nextSlide();
			}
		}, 100);
	});

	$('#si-replay').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(0);
	});

	$('#si-exit').on('click touch', function () {
		siAudio.sfx.click.play();
		window.close();
	});

	$('#si-start').on('click touch', function () {
		siAudio.sfx.click.play();
		if (slides[globalVar.curSlide].nextAction) {
			slides[globalVar.curSlide].nextAction();
		} else {
			nextSlide();
		}
	});

	$('#si-submit').on('click touch', function () {
		var thisSlide = slides[globalVar.curSlide];
		if (thisSlide.type === 'form' && !validForm()) return;

		siAudio.sfx.click.play();
		var bol = checkQuestion(thisSlide.type);
		handleAnswer(bol);
	});

	$('#si-reset').on('click touch', function () {
		siAudio.sfx.click.play();
		switch (slides[globalVar.curSlide].type) {
			case 'dnd':
				var dndArgs = dndResetObject[globalVar.curSlide];
				resetDnD(dndArgs.time, dndArgs.answers);
				break;
			case 'sort':
				resetSort();
				break;
			case 'quiz':
				resetQuiz();
				break;
			case 'hotspot':
				resetHotspot();
				break;
			default:
				if (slides[globalVar.curSlide].customReset) {
					slides[globalVar.curSlide].customReset();
				}
				break;
		}
	});
	$('#si-custom-submit').on('click touch', function () {
		var thisSlide = slides[globalVar.curSlide];
		if (thisSlide.type === 'form' && !validForm()) return;

		siAudio.sfx.click.play();
		if (slides[globalVar.curSlide].customSubmit) {
			slides[globalVar.curSlide].customSubmit();
		}
	});

	$('.si-menu-closer').on('click touch', function () {
		closeSideMenu();
	});

	$('#handlebars-button1').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(4);
		$('.modal-close').trigger('click');
	});

	$('#handlebars-button2').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(5);
		$('.modal-close').trigger('click');
	});

	$('#front-wheel-button1').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(6);
		$('.modal-close').trigger('click');
	});

	$('#front-wheel-button2').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(7);
		$('.modal-close').trigger('click');
	});

	$('#bike-button3').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(8);
	});

	$('#seat-button1').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(9);
		$('.modal-close').trigger('click');
	});

	$('#seat-button2').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(10);
		$('.modal-close').trigger('click');
	});

	$('#bike-button5').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(11);
	});

	$('#bike-button6').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(12);
	});

	$('#bike-button7').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(13);
	});

	$('#handlebars-button1').on('click touch', function () {
		$(this).addClass('handlebars-clicked').addClass('show-brakes-cable');
		// stopAll();
	});

	$('#handlebars-button2').on('click touch', function () {
		$(this).addClass('handlebars-clicked').addClass('show-brakes-cable');
		// stopAll();
	});

	$('#front-wheel-button1').on('click touch', function () {
		$(this).addClass('front-wheel-clicked');
		// stopAll();
	});

	$('#front-wheel-button2').on('click touch', function () {
		$(this).addClass('front-wheel-clicked');
		// stopAll();
	});

	$('#seat-button1').on('click touch', function () {
		$(this).addClass('seat-clicked');
		// stopAll();
	});

	$('#seat-button2').on('click touch', function () {
		$(this).addClass('seat-clicked');
		// stopAll();
	});

	$('#handlebars-start img').on('click touch', function () {
		$('.button1').trigger('click');
	});

	$('#front-wheel-start img').on('click touch', function () {
		$('#bike-button2').trigger('click');
	});

	$('#training-wheels-start img').on('click touch', function () {
		$('#bike-button3').trigger('click');
	});

	$('#seat-start img').on('click touch', function () {
		$('#bike-button4').trigger('click');
	});

	$('#pedals-start img').on('click touch', function () {
		$('#bike-button5').trigger('click');
	});

	$('#brakes-start img').on('click touch', function () {
		$('#bike-button6').trigger('click');
	});

	$('.button7-background img').on('click touch', function () {
		$('#bike-button7').trigger('click');
	});

	$('#bike-button1').hover(function () {
		$('.button1-background-red').fadeToggle();
	});

	$('#bike-button2').hover(function () {
		$('.button2-background-red').fadeToggle();
	});

	$('#bike-button3').hover(function () {
		$('.button3-background-red').fadeToggle();
	});

	$('#bike-button4').hover(function () {
		$('.button4-background-red').fadeToggle();
	});

	$('#bike-button5').hover(function () {
		$('.button5-background-red').fadeToggle();
	});

	$('#bike-button6').hover(function () {
		$('.button6-background-red').fadeToggle();
	});

	$('#bike-button7').hover(function () {
		$('.button7-background-red').fadeToggle();
	});
}

// var menuSound = new Audio('media/audio/pacific-cycle/menu.mp3');
// var handlebarsSound = new Audio('media/audio/pacific-cycle/handlebars-submenu.mp3');
// var frontWheelSound = new Audio('media/audio/pacific-cycle/front-wheel-submenu.mp3');
// var seatSound = new Audio('media/audio/pacific-cycle/seat-submenu.mp3');

// $('#bike-button1').on('click touch', function () {
// 	stopAll('handlebars');
// 	// handlebarsSound.play();
// });

// $('#bike-button2').on('click touch', function () {
// 	stopAll('frontWheel');
// 	// frontWheelSound.play();
// });

// $('#bike-button4').on('click touch', function () {
// 	stopAll('seat');
// 	// seatSound.play();
// });

// $('.modal-close').on('click touch', function () {
// 	stopAll();
// });

// $('.hotspot-modal-blocker').on('click touch', function () {
// 	stopAll();
// });

// function stopAll(section) {
// 	if (section === 'handlebars') {
// 		// menuSound.pause();
// 		// menuSound.currentTime = 0;
// 		// frontWheelSound.pause();
// 		// frontWheelSound.currentTime = 0;
// 		// seatSound.pause();
// 		// seatSound.currentTime = 0;
// 	} else if (section === 'seat') {
// 		// menuSound.pause();
// 		// menuSound.currentTime = 0;
// 		// frontWheelSound.pause();
// 		// frontWheelSound.currentTime = 0;
// 		// handlebarsSound.pause();
// 		// handlebarsSound.currentTime = 0;
// 	} else if (section === 'frontWheel') {
// 		// menuSound.pause();
// 		// menuSound.currentTime = 0;
// 		// seatSound.pause();
// 		// seatSound.currentTime = 0;
// 		// handlebarsSound.pause();
// 		// handlebarsSound.currentTime = 0;
// 	} else {
// 		// menuSound.pause();
// 		// menuSound.currentTime = 0;
// 		// seatSound.pause();
// 		// seatSound.currentTime = 0;
// 		// handlebarsSound.pause();
// 		// handlebarsSound.currentTime = 0;
// 		// frontWheelSound.pause();
// 		// frontWheelSound.currentTime = 0;
// 	}
// }

// function playMenuAudio() {
// 	menuSound.play();
// }

function hideClickIcon() {
	$('#' + globalVar.curSlide).off('mousedown.icon');
	$('#' + globalVar.curSlide).on('mousedown.icon', function () {
		$('#si-click-icon').hide();
		$('#' + globalVar.curSlide).off('mousedown.icon');
	});
}

// function used by fullscreen nav button
function toggleFullscreen() {
	var element = document.documentElement;
	var fullscreen =
		document.fullscreenElement ||
		document.mozFullScreenElement ||
		document.msFullscreenElement ||
		document.webkitFullscreenElement;
	if (fullscreen) {
		var requestMethod =
			document.exitFullscreen ||
			document.webkitExitFullscreen ||
			document.webkitExitFullScreen ||
			document.mozCancelFullScreen ||
			document.msExitFullscreen;

		if (requestMethod) {
			requestMethod.apply(document);
		}
	} else {
		var requestMethod =
			element.requestFullscreen ||
			element.webkitRequestFullscreen ||
			element.webkitRequestFullScreen ||
			element.mozRequestFullScreen ||
			element.msRequestFullscreen;

		if (requestMethod) {
			requestMethod.apply(element);
		}
	}
}

// function infoKeyboard() {
//     var infoItems = $('.infoItem');
//     var idx = 0;
//     $('#Info_Closer').focus();

//     $('body').on('keydown.drag', function (event) {
//         switch (event.keyCode) {
//             case 9: //restricts tab movement to info overlay elements
//                 event.preventDefault();
//                 if (idx < infoItems.length - 1) {
//                     idx += 1;
//                 } else {
//                     idx = 0;
//                 }
//                 $(infoItems[idx]).focus();
//                 break;
//             case 27: // allows user to press escape key to return to normal
//                 $('#Info_Closer').trigger('click');
//                 break;
//             default:
//                 return true;
//         }
//     });
// }
